import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {InputWrapper} from 'ui-library';
import i18n from 'i18n';
import {DebounceInput, FormLabel} from 'apps/shared/components';

const InfluencerForm = (props) => {
  const {
    showPassword,
    email,
    password,
    onInputChange,
    onShowPassword
  } = props;

  return (
    <div className='vf-input-group'>
      <FormLabel htmlFor='email'>
        {i18n.get('LOGIN_EMAIL')}
      </FormLabel>

      <InputWrapper className='lg'>
        <i
          className='vf-icon icon-mail'
          style={{
            fontSize: '2.5rem',
            lineHeight: '2.5rem',
            top: '55%',
            left: '1.5rem'
          }}
        />

        <DebounceInput
          autoComplete='nope'
          className='register-input'
          hasError={email.hasError}
          onChange={event => onInputChange(event, 'email')}
          placeholder={i18n.get('REGISTER_EMAIL_PLACEHOLDER')}
          style={{paddingLeft: '6rem', fontSize: '2rem'}}
          type='email'
          value={email.value}
        />
      </InputWrapper>

      <FormLabel htmlFor='password'>
        {i18n.get('LOGIN_PASSWORD')}
      </FormLabel>

      <InputWrapper className='lg password-wrapper'>
        <i
          className='vf-icon icon-locked'
          style={{
            fontSize: '2.5rem',
            lineHeight: '2.5rem',
            top: '55%',
            left: '1.5rem'
          }}
        />

        <DebounceInput
          autoComplete='new-password'
          className='register-input'
          hasError={password.hasError}
          onChange={event => onInputChange(event, 'password')}
          placeholder={i18n.get('REGISTER_PASSWORD_PLACEHOLDER')}
          style={{paddingLeft: '6rem', fontSize: '2rem'}}
          type={showPassword ? 'text' : 'password'}
          value={password.value}
        />
        <i
          className={classnames('vf-icon show-password', {
            'icon-eye-disabled': showPassword,
            'icon-eye-1': !showPassword
          })}
          onClick={onShowPassword}
        />
      </InputWrapper>
    </div>
  );
};

InfluencerForm.propTypes = {
  showPassword: PropTypes.bool,
  email: PropTypes.object.isRequired,
  password: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onShowPassword: PropTypes.func.isRequired
};

InfluencerForm.defaultProps = {
  showPassword: false
};


export default InfluencerForm;
